import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/demo',
    name: 'index',
    component: () => import('../views/demo/index.vue')
  },
  {
    path: '/power',
    name: 'power',
    component: () => import('../views/power/index.vue')
  },
  {
    path: '/device',
    name: 'device',
    component: () => import('../views/device/index.vue')
  },
  {
    path: '/weather',
    name: 'weather',
    component: () => import('../views/weather/index.vue')
  }
]
const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router